import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";
import { useMutation, useQueryClient } from "react-query";

const useUpdateVesselImages = () => {
  const { token } = useContext(AuthContext);
  const queryClient = useQueryClient();

  const updateVesselImages = async ({ vesselId, images }) => {
    const formData = new FormData();
    images.forEach((image) => {
      formData.append("images", image);
    });

    const response = await fetch(
      `${process.env.REACT_APP_SERVER_URL}/vessel/update/images/${vesselId}`,
      {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      }
    );

    if (!response.ok) {
      const errorResponse = await response.json();
      throw new Error(errorResponse.message || "Failed to update vessel images");
    }

    return response.json();
  };

  return useMutation(updateVesselImages, {
    onSuccess: () => {
      queryClient.invalidateQueries("vessels");
    },
    onError: (error) => {
      console.error("Error updating primary information:", error);
    },
  });

};

export default useUpdateVesselImages;
